import {Box, IconButton, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Popover} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBell, faComment, faPhone, faPhoneMissed, faPhoneVolume} from "@fortawesome/pro-solid-svg-icons";
import React, {useEffect, useRef, useState} from "react";
import {gql, useMutation, useQuery} from "@apollo/client";
import ListItemSecondaryActionTime from "../../ListItems/ListItemSecondaryActionTime";
import {useRouter} from "next/router";
import {getNavigateUrl} from "../utils";

/*
tatt fra NotificationBell i Youtello-mobile
*/
const GET_BELLLIST = gql`
		query BellList($_nin: [String!] = "") {
			notificationSends(
				limit: 30
				orderBy: { createdAt: DESC }
				where: { category: { _nin: $_nin } }
			) {
				id
				title
				body
				userIdTo
				userIdCreated
				createdAt
				seen
				activityId
				doNavigateParams
				doNavigateScreen
				category
			}
		}
	`;
const SET_NOTIFICATION_SEEN = gql`
		mutation BellSeen($id: uuid = "") {
			updateNotificationSend(pkColumns: { id: $id }, _set: { seen: true }) {
				id
				seen
			}
		}
	`;

const NotificationBellListItem = ({notification, setOpen}) => {
	const router = useRouter();
	const [setBellSeen] = useMutation(SET_NOTIFICATION_SEEN);

	const notificationType = {
		phone_cc_pre_call: { icon: faPhoneVolume, type: "Before call" },
		message: { icon: faComment, type: "Message" },
		phone_emp_post_call: { icon: faPhone, type: "After call" },
		phone_register_pre_call: { icon: faPhoneVolume, type: "Before call" },
		phone_register_lost_call: { icon: faPhoneMissed, type: "Lost call" },
		phone_emp_lost_call: { icon: faPhoneMissed, type: "Lost call" },
		phone_emp_pre_call: { icon: faPhoneVolume, type: "Before call" },
		phone_register_post_call: { icon: faPhone, type: "After call" },
		phone_cc_post_call: { icon: faPhone, type: "After call" },
		phone_cc_lost_call: { icon: faPhoneMissed, type: "Lost call" },
		phone_register_lost_call_outgoing: { icon: faPhoneMissed, type: "Lost call" },
		phone_emp_lost_call_outgoing: { icon: faPhoneMissed, type: "Lost call" },
		default: { icon: faBell, type: "Unknown" }
	};
	const notificationTypeObject = notificationType[notification.category] || notificationType.default;

	const title = notification.title?.trim().startsWith("💬") ? notification.title?.slice("💬".length) : notification.title;
	// console.log(title);
	return (
		<ListItemButton
			key={notification.id}
			onClick={() => {
				// console.log("Set bell seen", notification.id, title);
				setOpen(false);
				const {title, body, doNavigateParams, category} = notification;
				setBellSeen({ variables: { id: notification.id } })
					.then(() => {
						const test = JSON.parse(doNavigateParams);
						// console.log("Test:", test);
						const url = getNavigateUrl(JSON.parse(doNavigateParams), category);
						// console.log("Info:", JSON.parse(doNavigateParams), category);
						router.push(url);
					});
			}}
			divider
			sx={{borderRadius: 0}}
		>
			<ListItemAvatar>
				<FontAwesomeIcon icon={notificationTypeObject.icon} size={"lg"} fixedWidth color={"#6e6e6e"}/>
			</ListItemAvatar>
			<ListItemText
				primary={title}
				secondary={notification.body}
			  	slotProps={{
					primary: { sx: { fontWeight: "bold" } },
					secondary: { sx: { marginRight: 3}}
			  	}}
			>
			</ListItemText>
			{!notification?.seen &&
				<ListItemText sx={{display: "flex", alignItems: "center", justifyContent: "end"}}>
					<Box
						sx={{
							width: 10,
							height: 10,
							backgroundColor: "rgb(75,139,255)",
							borderRadius: "50%",
							marginLeft: 1
						}}/>
				</ListItemText>
			}
			<ListItemSecondaryActionTime sx={{width: "76px"}} time={notification.createdAt} />
		</ListItemButton>
	);
};

const NotificationBell = () => {

	const [anchorEl, setAnchorEl] = useState(null);
	const [open, setOpen] = useState(false);
	const [doTheShake, setDoTheShake] = useState(false);
	const [unseenNotificationsCount, setUnseenNotificationsCount] = useState(0);
	const { data, loading, error, refetch } = useQuery(GET_BELLLIST,
		{
			// skip: !open,
			variables: {
				_nin: ["phone_cc_pre_call", "phone_register_pre_call", "phone_emp_pre_call"]
			},
			fetchPolicy: "cache-and-network"
		});

	// every 30 seconds set doTheShake to true for 1 second
	useEffect(() => {
		const interval = setInterval(() => {
			if (unseenNotificationsCount > 0) {
				setDoTheShake(true);
				setTimeout(() => {
					setDoTheShake(false);
				}, 1000);
			}
		}, 30000);
		return () => clearInterval(interval);

	}, []);

	useEffect(() => {
		if (open) {
			refetch();
		}
	}, [open]);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
		setOpen(true);
	};

	const handleClose = () => {
		setAnchorEl(null);
		setOpen(false);
	};

	useEffect(() => {
		// console.log("new data: ", data);
		// count all notifications that are not seen
		const unseenNotifications = data?.notificationSends?.filter((notification) => !notification.seen);
		setUnseenNotificationsCount(unseenNotifications?.length);
	}, [data]);

	return (
		<>
			<Box sx={{ mr: 1.5 }}>
				<IconButton
					onClick={handleClick}
				>
					<Box className={"fa-layers fa-fw"} style={{width: "42px", height: "34px"}}>
						<FontAwesomeIcon
							icon={faBell}
							size={"sm"}
							color={"#6e6e6e"}
							shake={doTheShake}
							style={{ "--fa-animation-duration": "3s" }}
						/>
						{/*unseenNotificationsCount er ikke helt ferdig,
						* skip: !open, gjør at den ikke henter data før man åpner den
						* og dermed vil den ikke vise antall nye notifikasjoner
						* med mindre den er åpnet.
						* se utkommentert kode setUnseenNotificationsCount(unseenNotifications?.length);
						*/}
						{unseenNotificationsCount > 0 &&
							<Box
								component={"span"}
								className={"fa-layers-counter"}
								style={{fontSize: "1.5em", "--fa-left": "30px"}}
							>
								{unseenNotificationsCount}
							</Box>
						}
					</Box>
				</IconButton>
				<Popover
					open={open}
					onClose={handleClose}
					sx={{height: "500px"}}
					anchorEl={anchorEl}
					anchorOrigin={{vertical: "bottom", horizontal: "right"}}
					transformOrigin={{vertical: "top", horizontal: "right"}}
				>
					<List
						sx={{width: "600px"}}
						disablePadding
					>
						{data?.notificationSends?.map((notification) => (
							<NotificationBellListItem key={notification?.id} notification={notification} setOpen={setOpen} />
						))}
					</List>
				</Popover>
			</Box>
		</>
	);
};



export default NotificationBell;
